import Icon from '../../components/Icon.vue'

Icon.register({"brands/typo3":{"width":433,"height":512,"paths":[{"d":"M330.8 341C323.8 343.3 319.2 343.3 312.3 343.3 255.1 343.3 171.7 144.8 171.7 78.4 171.7 53.7 177.1 46 185.6 39 116.1 47.5 36.3 73 9.3 105.4 3.9 113.1 0 126.2 0 142.5 0 246 106.8 480 184.1 480 220.4 480 281.4 420.5 330.8 341M294.5 32C366.3 32 433.3 43.6 433.3 84.5 433.3 167.1 380.8 266.8 354.5 266.8 306.6 266.8 252.8 134.7 252.8 68.3 252.8 37.4 264.4 32 294.5 32"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/brands/typo3.js
// module id = null
// module chunks = 